import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
export var ButtonGoto = function (_a) {
    var onClick = _a.onClick, buttonType = _a.buttonType, destinationIcon = _a.destinationIcon;
    var RenderButton = buttonType;
    return (React.createElement(RenderButton, { onClick: onClick },
        React.createElement(Icon, { icon: IdIcon.RedArrowIcn, styleId: IdStyles.IconLarge }),
        React.createElement(Icon, { icon: destinationIcon, styleId: IdStyles.IconLarge })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/ButtonGoto.tsx
// module id = 438
// module chunks = 3